import { render, staticRenderFns } from "./GoodsPreview.vue?vue&type=template&id=6cf00068&scoped=true&"
import script from "./GoodsPreview.vue?vue&type=script&lang=js&"
export * from "./GoodsPreview.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPreview.vue?vue&type=style&index=0&id=6cf00068&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf00068",
  null
  
)

export default component.exports